export const parseParams = (payload) => {
  const equalitySign = '='
  const spliterator = '?'

  const params = new Map()

  if (payload && typeof payload === 'string' && payload.includes(spliterator)) {
    const strings = payload.substring(payload.indexOf(spliterator) + 1).split(spliterator)

    strings.forEach(string => {
      const keyValuePair = string.split(equalitySign)
      params.set(keyValuePair[0], keyValuePair[1])
    })
  }
  return params
}

export const hasPayloadValue = (payload, key, value) => {
  const REGEX = /\\u([0-9]|[a-fA-F])([0-9]|[a-fA-F])([0-9]|[a-fA-F])([0-9]|[a-fA-F])/g
  const spliterator = '?attributes='

  if (payload && typeof payload === 'string' && payload.includes(spliterator)) {
    const attributes = payload.split(spliterator)
    if (attributes[1] !== undefined) {
      const attributesDecode = window.atob(attributes[1]).substr(2)
      const attributesStr = JSON.stringify(attributesDecode).replace(REGEX, '')
      const attributesObj = JSON.parse(JSON.parse(attributesStr))
      return attributesObj.some(m => m.name === key && m.value === value)
    }
  }
  return false
}
